import React, { useCallback, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import "./add-wallet-money.css";

import RazorPaySVG from "../../utils/Razorpay.svg";


import PaytmSVG from "../../utils/Paytm.svg";
import api from '../../api/api';
import Cookies from 'universal-cookie';
import useRazorpay from 'react-razorpay';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { addUserBalance } from '../../model/reducer/authReducer';
import PaystackPop from '@paystack/inline-js';
import { CardElement, Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import Loader from '../loader/Loader';
import { loadStripe } from '@stripe/stripe-js';
import InjectCheckout from './AddWalletStripeModal';

const AddWalletModal = (props) => {
    const cookies = new Cookies();
    const { t } = useTranslation();

    const setting = useSelector(state => state.setting);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();

    const [walletAmount, setWalletAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState("Paypal");
    const [stripeTransId, setStripeTransId] = useState(null);
    const [stripeClientSecret, setstripeClientSecret] = useState(null);
    const [stripeModalShow, setStripeModalShow] = useState(false);
    const handleAmountChange = (e) => {
        const amt = parseInt(e.target.value);
        setWalletAmount(amt);
    };

    const handlePmtMethodChange = (value) => {
        setPaymentMethod(value);
    };


    const stripePromise = loadStripe(setting.payment_setting && setting.payment_setting.stripe_publishable_key);


    const initializeRazorpay = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            // document.body.appendChild(script);

            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };

            document.body.appendChild(script);
        });
    };

    const [Razorpay] = useRazorpay();

    const handleRazorpayPayment = useCallback(async (razorpay_transaction_id, amount, name, email, mobile, app_name) => {
        const res = await initializeRazorpay();
        if (!res) {
            console.error("RazorPay SDK Load Failed");
            return;
        }
        const key = setting.payment_setting && setting.payment_setting.razorpay_key;
        const convertedAmount = Math.floor(amount * 100);
        const options = {
            key: key,
            amount: convertedAmount,
            currency: "INR",
            name: name,
            description: app_name,
            image: setting.setting && setting.setting.web_settings.web_logo,
            order_id: razorpay_transaction_id,
            handler: async (res) => {
                // console.log(res);
                if (res.razorpay_payment_id) {
                    await api.addTransaction(localStorage.getItem('jwt_token'), null, razorpay_transaction_id, "Razorpay", "wallet", amount)
                        .then(response => response.json())
                        .then(result => {
                            // console.log(result);
                            if (result.status === 1) {
                                props.setShowModal(false);
                                toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                                dispatch(addUserBalance({ data: parseInt(amount) }));
                            }
                            else {
                                toast.error(result.message);
                            }
                        })
                        .catch(error => console.log(error));
                }


            },
            modal: {
                confirm_close: true,
                ondismiss: async (reason) => {
                    if (reason === undefined) {
                        props.setShowModal(false);
                    }
                }
            },
            prefill: {
                name: name,
                email: email,
                contact: mobile,
            },
            notes: {
                address: "Razorpay Corporate ",
            },
            theme: {
                color: setting.setting && setting.setting.web_settings.color,
            },
        };
        const rzpay = new window.Razorpay(options);
        rzpay.on('payment.cancel', function (response) {
            toast.error(response, { hideProgressBar: true, autoClose: 1000 });
            props.setShowModal(false);
        });
        rzpay.on('payment.failed', function (response) {
            toast.error(response, { hideProgressBar: true, autoClose: 1000 });
        });
        rzpay.open();
    }, [Razorpay]);

    const handlePayStackPayment = (email, amount, currency, support_email, orderid) => {
        let handler = PaystackPop.setup({
            key: setting.payment_setting && setting.payment_setting.paystack_public_key,
            email: email,
            amount: parseFloat(amount) * 100,
            currency: currency,
            ref: (new Date()).getTime().toString(),
            label: support_email,
            callback: async function (response) {
                await api.addTransaction(localStorage.getItem('jwt_token'), null, response.reference, "Paystack", "wallet", amount)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === 1) {
                            toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                            dispatch(addUserBalance({ data: parseInt(amount) }));
                            props.setShowModal(false);
                        }
                        else {
                            toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                            props.setShowModal(false);
                        }
                    })
                    .catch(error => console.log(error));
            }
        });

        handler.openIframe();
    };
    const handlePaypalPayment = async (redirectUrl) => {
        const newWindow = window.open(redirectUrl, "_parent");
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let response, result;

            if (paymentMethod === "razorpay") {
                handleRazorpayPayment(result?.data?.transaction_id, walletAmount, user?.user?.name, user?.user?.email, user?.user?.mobile, setting.setting?.app_name);

            } else if (paymentMethod === "midtrans") {
                const windowWidth = 700;
                const windowHeight = 700;
                const windowLeft = window.screen.width / 2 - windowWidth / 2;
                const windowTop = window.screen.height / 2 - windowHeight / 2;
                const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${windowLeft},top=${windowTop},resizable=yes,scrollbars=yes,status=yes`;
                const paymentWindow = window.open(result?.data?.snapUrl, "_blank", windowFeatures);
                const messageEventListener = async (event) => {
                    if (event.data === "Recharge Done") {
                        paymentWindow.close();
                        dispatch(addUserBalance({ data: walletAmount }));
                        toast.success(t("wallet_recharge_successfull", { hideProgressBar: true, autoClose: 1000 }));
                        props.setShowModal(false);
                        // Remove the event listener once the task is completed
                        window.removeEventListener("message", messageEventListener);
                    }
                };

                // Add the event listener
                window?.addEventListener("message", messageEventListener);
                paymentWindow.onbeforeunload = () => {
                    // Remove the event listener if the payment window is closed without making payment
                    window.removeEventListener("message", messageEventListener);
                };
            }
        } catch (err) {
            console.log(err.message);
        }
    };
    return (
        <>

            <Modal
                className='addMoneyToWalletModal'
                size='md'
                centered
                show={props.showModal}
                backdrop={"static"}
            >
                <Modal.Header className='d-flex justify-content-between'>
                    <div className='fw-bold modalHeading'>
                        {t("add_to_wallet")}
                    </div>
                    <div className='closeModalBtn' onClick={() => props.setShowModal(false)}><AiOutlineCloseCircle size={34} /></div>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className='d-flex flex-column justify-content-start'>
                            <div>
                                <div className='mb-3'>{t("amount")}</div>
                                <div className='w-100 mb-5'>
                                    <input
                                        type='number'
                                        required
                                        className='moneyAmountPlaceholder w-100 text-start'
                                        placeholder={t("type_amount")}
                                        onChange={handleAmountChange} />
                                </div>
                                <div>
                                    <div className='mb-4'>
                                        {t("choose_payment_method")}
                                    </div>
                                    <div className='d-flex flex-column gap-4'>

                                        <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                            <div>
                                                <img className='me-3' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAwFBMVEX///8zlf8HJlQAF0yAi58nkf+Swv8sk/8ej/8ikP8AAESXxP8AAEMAI1IXjf/w9/8AEEoAHE8AIFH3+//n8v+gyf/b6/93tP9Enf/G3/9Ypf/U5//z+f+AuP++2v/M4v/t7/IAC0iwtsJmrP87mf+u0f+Ivf/g7v+pzv+eprXa3uRrd46Ol6kAAEdWpP+/2/+6wMtdaoVOXXoxRWnN0tonPWQTL1s8TnCIkaPS1t3m6OwrPmSZobBRYX51f5UAADkibHbFAAAFzklEQVR4nO2ceVfqSBDFSWJIghA2EURQZPO54/qezozz/b/V0B2IWSqxVTidYu7vD4UI51Sd6k7f26m2VAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANgtBge6I9gyR35ddwhbZdD1b3XHsFVmtmPv6w5iixxMfMPwT3WHsT1mnm0Yhqs7jK1x3l8W0DCcie5AtkXHc0SChvdLdyTb4bDnGgHuoe5YtkLZd1YJGo7uWLbB8dRb52fYXd3RbJ720A0LuBykJ7rj2ThHU9uI4O2aKB10XSNGT3dEG+bEseMJ2nPdIW2U+sQ3EvhHuoPaJDPXTiZoODvknA76bio/w+nrDmtzdKJLxMc07OiOa1Mc3hIFFKvhse7INsQ+WUBBW3doG+G452XktyPOaehnFdDwZrqD2wAJkRbHP9cd3o9JibQ4U93x/ZgTI6eAy7ViqDvAH1Kf5BaQv3OaJVV2ehqylmykSIvjsHZOtEhLTMOy7ii/T5ZIS0xDvs4pW6TFM+Qq2Y57KgVk7JzmagVk65xOp1kqOz1IOTqndje1EZMzSnVH+w3uMtZ4hxq3HJ3TPKOAbn9CpMjROWUMRq9TuiUydPk5p0NykXD7B6U6NUoZOqdfxF3UlmPxhNpHZOic+ulK+RPpHobUIOXnnNqp+6jtrLKYEoPU4+ecTpND0e2udOc5MXwdhm1C+/EaetPQOcyoCcrQOfViJfLnH8ahS+gAhm1C9ehy702jmpMSOg4/5xRZERw/1ql2SEgdjpJtGFbKvV2rldFI/OwQ05Bjm1B4C/FC27eoyl/EOmn4/NqEzldD0Z+seytG99V/5AtSzOmL9LsEks12QsMwblqNC/HilJiGHNuEpD9aibQlbw83NbNyKV6WiVspQ+fUdiIirVS6qDRNs9aQrynn5PNrE1oORX8t0kqXjxVzSfNKvKlTtpihcyr701CkXFdaIkHzbCzekc6JYZtQLxRpT88NM+DsTbwfEtPQvdMY6vcYhAV8v2mtEqw9ywu9dIKGy885rXl6WRfQNK09ceWckmxsnzm1r6q1MEGzshDXSOfE9YDF2LLMCNZIXKT2EX2Om91LkfZQqUUTbP0WV9vUBgZD57Tk4qxpxrCuxeXjHXFOgUiLU3kSf+hQko2hc7puJAq4XCtqcihSzonfAYvLx7NkfkvJJp3Tbmx2/6m20gmagXM6IiQbN+cUXeOjVKVzmlOSjdVmd/uqkrzDrKbhi/w7Kdk4OaeFaZH5rZ3TAeUrGEm2UVYBzTznxOiAxbiZVUAxDbOdE5c2oaRIi9MKnBO1VrgDzZErIjdisslxTjzahFYbMTmDVDon8qEwizah6/wCigylZKOcE4c2oVdKpCWmoXRO5DMnT3P0CuzdUCItMQ0ZO6cskRbnRjqnfYbOKb4Rk02w2U0+cyp2m9DCylnjIzQfxKcH1DOnQnfrje7z1vhYCbOdU6HbhDJVdorgmdOcW5vQW1U1wbVzIjK0i+ycxp+ugmu4Oqerz3RMSI5zKnSbkKV4m1k/c2LXJnSpPA1bj/IL5GZ3kZ3ThYqWkQTOiWqnLbZzuleehlydk3IJzcZIfJ6dc3r6xPJ+0JKSrU1udhf5mdO1sqAJnBO/NqHfn5vCFZVs51TkNqGRsqCpWfILlGQrdJvQQnk1bN6Lz5NtQoWWbO/K0zBwTnfsDlj8pTwNq0yd041qgrWm/AIl2fwiS7YvOydql63QByzUJVvgnPgdsDCVnVOFp3N6VZ+GwQYGMQsNX3MSufz9VefEbrP7QV2ySedEtgkV2Tm1le+kec6pyG1CX3BO8pnTgDy5rTuLPP580TkdsXNOz+rT8FV8njpg4RbaOalvdpvSxFMHLAr9f1gX6pIt6NajHv3ulHPid8DiRV2ySefE7oDF5b+WIo2VZPPsFIU+YPH6vqeKHKT18r6kHKXIggYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8//gNTZGO97VtsDAAAAABJRU5ErkJggg=="
                                                    alt="Razorpay" width="45" height="50" />
                                                {t("razorpay")}
                                            </div>


                                            <div>
                                                <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("razorpay")} />
                                            </div>
                                        </div>

                                        {/* <div className='d-flex flex-row justify-content-between align-items-center paymentContainer'>
                                            <div>
                                                <img className='me-2' src={PaytmSVG} alt='paytmSVG' />
                                                {t("Paytm")}
                                            </div>
                                            <div>
                                                <input type='radio' id='paymentRadioBtn' name='paymentRadioBtn' onChange={() => handlePmtMethodChange("paytm")} />
                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='d-flex justify-content-end'>
                            <button type='submit' className='payButton'>{t("add_money")}</button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
            <Modal id="stripeModal" size='lg' centered show={stripeModalShow}>
                <Modal.Header onClick={() => setStripeModalShow(false)

                } className='header justify-content-between'>
                    <span style={{ color: '#33a36b', fontSize: '18px', fontWeight: 'bolder' }}>My Ace Bazar Payment</span>
                    <span style={{ cursor: 'pointer' }}>
                        <AiOutlineCloseCircle size={20} />
                    </span>

                </Modal.Header>
                <Modal.Body>

                    {stripeClientSecret === null || stripeTransId === null
                        ? <Loader width='100%' height='100%' />
                        :
                        <Elements stripe={stripePromise} client_secret={stripeClientSecret} transaction_id={stripeTransId} amount={walletAmount}>
                            <InjectCheckout setAddWalletModal={props.setShowModal} setShow={setStripeModalShow} stripe={stripePromise} client_secret={stripeClientSecret} transaction_id={stripeTransId} amount={walletAmount} />
                        </Elements>
                    }

                </Modal.Body>
            </Modal>
        </>

    );
};


export default AddWalletModal;